import { SHELF_LIST_GET_DONE } from "../../action/shelf";
const initState = {
    data: [],
    error: null,
    status: null,
    currentlogedInuser: null,
};

export const shelfReducer = (state = initState, action) => {
    switch (action.type) {
        case SHELF_LIST_GET_DONE:
            return {
                ...state,
                data: {
                    data: action?.payload?.data?.data,
                    status: action?.payload?.data?.status,
                    error: null,
                },
            };
        default:
            return state;
    }
};
